<h3 color="primary" class="popup-header">Label Printer</h3>
<mat-dialog-content class="mat-typography">
  <custom-popup-message></custom-popup-message>
  <div fxLayout="column">
    <mat-form-field fxFill>
      <mat-select disableOptionCentering placeholder="Label Printer" [(ngModel)]="labelPrinter">
        <mat-option>
          <ngx-mat-select-search [(ngModel)]="searchCtrlForprinter" [placeholderLabel]="'Search...'"
            [noEntriesFoundLabel]="'Not found'" name="search">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of printerList | stringFilterBy:searchCtrlForprinter:'name'" [value]="item.id">
          {{item?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="primary" (click)="saveClick()">
    <i class="fas fa-check"></i> Save
  </button>
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Cancel
  </button>
</mat-dialog-actions>